import { React, DomeRouter, DomeComponent, DomeManipulator, ObservableValue } from '@lexriver/dome'
import css from './LinkToCopy.m.scss'
import { Input } from './form/Input'


interface Attrs {
    url: string
    label?: string
}

/**
 * display a link that user can copy to clipboard or open in new window
 */
export class LinkToCopy extends DomeComponent<Attrs> {
    render() {
        return <div class={css.container}>
            {this.attrs.label && <label>{this.attrs.label}</label>}
            <div class={css.subContainer}>
                <Input value={this.attrs.url} />
                <div class={css.buttons}>
                    <button onClick={async () => { await navigator.clipboard.writeText(this.attrs.url); alert('Ссылка скопирована'); }} >копировать</button>
                    <button onClick={() => window.open(this.attrs.url, '_blank')?.focus()} >открыть</button>
                </div>
            </div>
        </div>
    }
}